import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { imgUrl } from "../../../../api/api";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";

const fmtDuration = (ms) => {
  if (!ms) return '0:00';
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

function PlaylistContentCardItem(props) {
  const { content, playID, deleteContent, addSchedule, updateTimeHandler } = props;
  const [previewOpen, setPreviewOpen] = useState(false);

  const thumbPreviewable = content.type === "image" || content.type === "video" || content.type === "url";

  useEffect(() => {
    if (!previewOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setPreviewOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [previewOpen]);

  const openPreview = (e) => {
    e?.stopPropagation?.();
    if (!thumbPreviewable) return;
    setPreviewOpen(true);
  };

  const urlHref =
    content.type === "url" && content.url
      ? /^https?:\/\//i.test(String(content.url).trim())
        ? String(content.url).trim()
        : `https://${String(content.url).trim()}`
      : "";

  const TypeIcon = content.type === 'video'
    ? <OndemandVideoIcon style={{ fontSize: 14, color: '#551FFF' }} />
    : content.type === 'image'
    ? <ImageIcon style={{ fontSize: 14, color: '#FF6A00' }} />
    : <LinkIcon style={{ fontSize: 14, color: '#00B7FE' }} />;

  return (
    <div className="pci-row">
      {/* 썸네일 — 클릭 시 크게 보기 (콘텐츠 목록과 동일) */}
      <div
        className={`pci-thumb${thumbPreviewable ? " pci-thumb--clickable" : ""}`}
        onClick={openPreview}
        role={thumbPreviewable ? "button" : undefined}
        tabIndex={thumbPreviewable ? 0 : undefined}
        onKeyDown={
          thumbPreviewable
            ? (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openPreview(e);
                }
              }
            : undefined
        }
        title={thumbPreviewable ? "클릭하여 크게 보기" : undefined}
      >
        {content.type === 'image' && (
          <img src={`${imgUrl}/${content.url}`} alt={content.name} onError={(e) => { e.target.style.opacity = "0.3"; }} />
        )}
        {content.type === 'video' && (
          <div className="pci-thumb-video">
            <video src={`${imgUrl}/${content.url}`} muted preload="metadata" />
            <OndemandVideoIcon style={{ position: 'absolute', color: 'white', fontSize: 18 }} />
          </div>
        )}
        {content.type === 'url' && (
          <div className="pci-thumb-url">
            <LinkIcon style={{ color: '#551FFF', fontSize: 22 }} />
          </div>
        )}
      </div>

      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          {content.name || content.url || "미리보기"}
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
          {content.type === "image" && (
            <img
              src={`${imgUrl}/${content.url}`}
              alt={content.name}
              style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 12 }}
            />
          )}
          {content.type === "video" && (
            <video
              src={`${imgUrl}/${content.url}`}
              style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 12 }}
              controls
              autoPlay
            />
          )}
          {content.type === "url" && (
            <div style={{ textAlign: 'center', width: '100%' }}>
              <LinkIcon sx={{ color: "#551FFF", fontSize: 48, mb: 1 }} />
              <p style={{ wordBreak: 'break-all', color: '#666', margin: '8px 0' }}>{content.url}</p>
              {urlHref && (
                <a href={urlHref} target="_blank" rel="noopener noreferrer" style={{ color: '#551FFF', fontWeight: 600 }}>
                  새 탭에서 열기
                </a>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* 파일명 + 타입 */}
      <div className="pci-info">
        <span className="pci-name" title={content.name}>{content.name || content.url}</span>
        <span className="pci-type">{TypeIcon} {content.type}</span>
      </div>

      {/* 재생 시간 (클릭하면 수정) */}
      <button
        className="pci-duration"
        onClick={() => updateTimeHandler(playID, content._id, content.duration)}
        title="클릭하여 재생 시간 수정"
      >
        <AccessTimeIcon style={{ fontSize: 13 }} />
        {fmtDuration(content.duration)}
      </button>

      {/* 액션 버튼 */}
      <div className="pci-actions">
        <button
          className="pci-action-btn pci-action-btn--schedule"
          onClick={() => addSchedule(playID, content._id)}
          title="스케줄"
        >
          <ScheduleSendIcon style={{ fontSize: 16 }} />
        </button>
        <button
          className="pci-action-btn pci-action-btn--delete"
          onClick={() => deleteContent(playID, content._id)}
          title="삭제"
        >
          <DeleteOutlineIcon style={{ fontSize: 16 }} />
        </button>
      </div>
    </div>
  );
}

export default PlaylistContentCardItem;
